/* 
    Custom Scripts 
*/
$(document).ready(function(){

    var hero_splideOptions = {
        type: "fade",
        perPage: 1,
        rewind: true,
        arrows: false,
        pagination: true,
        drag: true,
        autoplay: true,
    };

    var elms = document.getElementsByClassName( 'f-hro-splide' );
    for ( var i = 0; i < elms.length; i++ ) 
    {
        new Splide( elms[ i ], hero_splideOptions ).mount();
    }
    
    var splideOptions = {
        type: "slide",
        perPage: 4,
        perMove: 1,
        rewind: true,
        arrows: false,
        pagination: false,
        drag: true,
        autoplay: false,
        gap: 20,
        breakpoints: { 
            1024: { 
                perPage: 3,
                arrows: true
            }, 
            768: { 
                perPage: 2,
                arrows: true
            }, 
            480: { 
                perPage: 1.3,
                arrows: false,
                rewind: false,
                focus: 0,
                gap: 16,
            }
        }
    };

    var elms = document.getElementsByClassName( 'f-product-splide' );
    for ( var i = 0; i < elms.length; i++ ) 
    {
        new Splide( elms[ i ], splideOptions ).mount();
    }

    var SR_splideOptions = {
        type: "slide",
        perPage: 3,
        rewind: true,
        arrows: false,
        pagination: false,
        drag: true,
        autoplay: false,
        gap: 25,
        breakpoints: { 
            1024: { 
                perPage: 3,
                pagination: true
            }, 
            768: { 
                perPage: 2,
                pagination: true
            }, 
            480: { 
                perPage: 1.3,
                arrows: false,
                rewind: false,
                pagination: false,
                focus: 0,
                gap: 16,
            }
        }
    };

    var elms = document.getElementsByClassName( 'f-sr-splide' );
    for ( var i = 0; i < elms.length; i++ ) 
    {
        new Splide( elms[ i ], SR_splideOptions ).mount();
    }

});

